export enum TeamPermissionType {
  None,
  ReadOnly,
  Full
}
